import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';
import { getDatasPadrao } from '../../utils/relatorioDatas';
import './relatorioTempoColaborador.css';

const ETAPAS_LABELS = {
  SUPORTE_min: 'Atendimento',
  ANALISE_min: 'Em análise',
  DESENVOLVIMENTO_min: 'Em desenvolvimento',
  EM_TESTE_min: 'Em testes'
};

function RelatorioTempoColaborador() {
  const { datInic: defaultIni, datFina: defaultFim } = getDatasPadrao();
  const [datInic, setDatInic] = useState(defaultIni);
  const [datFina, setDatFina] = useState(defaultFim);
  const [usuarios, setUsuarios] = useState([]);
  const [chamados, setChamados] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingChamados, setLoadingChamados] = useState(false);
  const [erro, setErro] = useState('');
  const history = useHistory();

  function aplicarMascaraData(valor) {
    if (!valor) return '';
    const numeros = valor.replace(/\D/g, '').slice(0, 8);
    if (numeros.length <= 2) return numeros;
    if (numeros.length <= 4) return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
    return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
  }

  const verificar = async () => {
    const resultado = await verificandoApp('ATENDENTE');
    if (!resultado) history.push('/');
  };

  const buscarRelatorio = async () => {
    verificar();
    const datIni = (datInic || '').trim();
    const datFin = (datFina || '').trim();
    if (!datIni || !datFin) {
      setErro('Informe a data inicial e a data final.');
      return;
    }
    setErro('');
    setSelectedUsuario(null);
    setChamados([]);
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2') || '') + '/satis/relatorio-tempo-colaborador', {
        headers: { Authorization: token },
        params: { datIni, datFin }
      });
      const lista = Array.isArray(res.data?.usuarios) ? res.data.usuarios : [];
      setUsuarios(lista);
    } catch (err) {
      setUsuarios([]);
      setErro(err?.response?.data?.error || 'Erro ao buscar relatório.');
    } finally {
      setLoading(false);
    }
  };

  const abrirChamadosDoUsuario = async (usuario) => {
    if (!usuario || usuario.usuario_id == null) return;
    setSelectedUsuario(usuario);
    setChamados([]);
    setLoadingChamados(true);
    try {
      const token = localStorage.getItem('token');
      const datIni = (datInic || '').trim();
      const datFin = (datFina || '').trim();
      const res = await axios.get(
        ensureProtocol(localStorage.getItem('ipBackend2') || '') + '/satis/relatorio-tempo-colaborador/' + usuario.usuario_id,
        { headers: { Authorization: token }, params: { datIni, datFin } }
      );
      const lista = Array.isArray(res.data?.chamados) ? res.data.chamados : [];
      setChamados(lista);
    } catch (err) {
      setChamados([]);
      setErro(err?.response?.data?.error || 'Erro ao listar chamados do colaborador.');
    } finally {
      setLoadingChamados(false);
    }
  };

  const irParaChamado = (satNum) => {
    if (satNum != null) history.push('/historicoSati/' + satNum);
  };

  useEffect(() => {
    verificar();
  }, []);

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo relatorio-tempo-colaborador">
          <div className="page-header no-print">
            <h1>Relatório por colaborador (horas)</h1>
            <div className="toolbar flex-wrap">
              <div className="input-group" style={{ maxWidth: 420 }}>
                <input
                  value={datInic}
                  onChange={(e) => setDatInic(aplicarMascaraData(e.target.value))}
                  type="text"
                  className="form-control"
                  placeholder="Data inicial (dd/mm/aaaa)"
                />
                <input
                  value={datFina}
                  onChange={(e) => setDatFina(aplicarMascaraData(e.target.value))}
                  type="text"
                  className="form-control"
                  placeholder="Data final (dd/mm/aaaa)"
                />
                <button onClick={buscarRelatorio} className="btn btn-secondary" type="button" disabled={loading}>
                  <i className="fas fa-search" /> {loading ? 'Carregando...' : 'Pesquisar'}
                </button>
              </div>
            </div>
          </div>
          {erro && <div className="alert alert-warning no-print">{erro}</div>}
          {!loading && usuarios.length === 0 && !erro && (
            <p className="text-muted no-print">Informe o período e clique em Pesquisar.</p>
          )}
          {usuarios.length > 0 && (
            <div className="table-responsive">
              <table className="table table-bordered table-hover tabela-usuarios-tempo">
                <thead>
                  <tr>
                    <th>Colaborador</th>
                    <th>{ETAPAS_LABELS.SUPORTE_min}</th>
                    <th>{ETAPAS_LABELS.ANALISE_min}</th>
                    <th>{ETAPAS_LABELS.DESENVOLVIMENTO_min}</th>
                    <th>{ETAPAS_LABELS.EM_TESTE_min}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((u) => (
                    <tr
                      key={u.usuario_id}
                      className={selectedUsuario?.usuario_id === u.usuario_id ? 'table-active' : ''}
                      onClick={() => abrirChamadosDoUsuario(u)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && abrirChamadosDoUsuario(u)}
                    >
                      <td>{u.nome || u.usuario_id}</td>
                      <td>{formatMin(u.SUPORTE_min)}</td>
                      <td>{formatMin(u.ANALISE_min)}</td>
                      <td>{formatMin(u.DESENVOLVIMENTO_min)}</td>
                      <td>{formatMin(u.EM_TESTE_min)}</td>
                      <td><strong>{u.total_texto || formatMin(u.total_min)}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {selectedUsuario && (
            <div className="chamados-colaborador mt-4">
              <h2 className="h5 mb-2">Chamados de {selectedUsuario.nome || selectedUsuario.usuario_id}</h2>
              {loadingChamados && <p className="text-muted">Carregando chamados...</p>}
              {!loadingChamados && chamados.length === 0 && <p className="text-muted">Nenhum chamado no período.</p>}
              {!loadingChamados && chamados.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm tabela-chamados-tempo">
                    <thead>
                      <tr>
                        <th>Chamado</th>
                        <th>{ETAPAS_LABELS.SUPORTE_min}</th>
                        <th>{ETAPAS_LABELS.ANALISE_min}</th>
                        <th>{ETAPAS_LABELS.DESENVOLVIMENTO_min}</th>
                        <th>{ETAPAS_LABELS.EM_TESTE_min}</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {chamados.map((c) => (
                        <tr key={c.sat_num}>
                          <td>
                            <button type="button" className="btn btn-link p-0 text-primary" onClick={() => irParaChamado(c.sat_num)}>
                              {c.sat_num}
                            </button>
                          </td>
                          <td>{formatMin(c.SUPORTE_min)}</td>
                          <td>{formatMin(c.ANALISE_min)}</td>
                          <td>{formatMin(c.DESENVOLVIMENTO_min)}</td>
                          <td>{formatMin(c.EM_TESTE_min)}</td>
                          <td><strong>{c.total_texto || formatMin(c.total_min)}</strong></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

function formatMin(min) {
  if (min == null || min === 0) return '0min';
  const m = Number(min);
  const h = Math.floor(m / 60);
  return h > 0 ? `${h}h ${m % 60}min` : `${m}min`;
}

export default RelatorioTempoColaborador;
